import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../App";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [status, setStatus] = useState("Autenticando...");
  const processed = useRef(false);

  useEffect(() => {
    // Prevent multiple executions
    if (processed.current) return;
    processed.current = true;

    const handleCallback = async () => {
      // Get token and user data from URL parameters
      const token = searchParams.get("token");
      const userParam = searchParams.get("user");
      const redirectPath = searchParams.get("redirect") || "/";
      const error = searchParams.get("error");

      if (error) {
        toast.error("Error en la autenticación con Google");
        navigate("/login", { replace: true });
        return;
      }

      if (token && userParam) {
        try {
          const user = JSON.parse(decodeURIComponent(userParam));
          
          // Store token in localStorage
          localStorage.setItem("token", token);
          
          // Update auth context
          login(token, user);
          
          toast.success("¡BIENVENIDO!");
          
          // Clear URL params and navigate
          window.history.replaceState({}, document.title, redirectPath);
          navigate(redirectPath, { replace: true });
          
        } catch (e) {
          console.error("Error parsing user data:", e);
          toast.error("Error al procesar la autenticación");
          navigate("/login", { replace: true });
        }
      } else {
        // No token in URL - redirect to login
        navigate("/login", { replace: true });
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-zinc-700 border-t-primary rounded-full animate-spin mx-auto mb-4"></div>
        <p className="font-mono text-zinc-500">{status.toUpperCase()}</p>
      </div>
    </div>
  );
}
